export default __webpack_public_path__ + "static/media/large.fa8db258.jpg";